import { getFileExtension } from "lib/actions/files";
import AssetTypeIcon from "components/elements/Chip/AssetTypeIcon";
import { UploadIssue } from "../lib/types/UploadIssue";
import { useUploadPreprocessor } from "../UploadPreprocessorContext";
import MessageBanner, {
  MessageType,
} from "components/elements/MessageBanner/MessageBanner";

type Props = {
  uploadIssue: UploadIssue;
};
const UploadIssueFileCard = ({ uploadIssue }: Props) => {
  const { setSelectedUploadIssue, removeUploadIssue } = useUploadPreprocessor();

  const fileExtension = getFileExtension(uploadIssue.file.name);

  const onSelectUploadIssue = () => {
    setSelectedUploadIssue(uploadIssue);
  };

  const onRemoveUploadIssue = () => {
    removeUploadIssue(uploadIssue);
  };

  return (
    <MessageBanner messageType={MessageType.Warning} colourWidth="md">
      <div className="flex divide-x py-2">
        <div className="w-full space-y-2 px-3">
          <div>
            <h4>{uploadIssue.file.name}</h4>
          </div>
          <div className="flex items-center justify-between ">
            <AssetTypeIcon ext={fileExtension} />
            <div className="space-x-2 text-xxs">
              <button
                onClick={onRemoveUploadIssue}
                className="uppercase text-gray-500 hover:text-black"
              >
                Delete
              </button>
              <button
                onClick={onSelectUploadIssue}
                className="border border-black px-2 py-1 uppercase leading-tight text-black hover:bg-black hover:text-white"
              >
                Resolve
              </button>
            </div>
          </div>
        </div>
      </div>
    </MessageBanner>
  );
};

export default UploadIssueFileCard;
